import React from 'react';
import i18n from './src/i18n';
import { I18nextProvider } from 'react-i18next';
import { PageContextProvider } from './src/pageContext';

export const wrapRootElement = ({ element }) => {
  return <I18nextProvider i18n={i18n}>{element}</I18nextProvider>;
};

export const wrapPageElement = ({ element, props }) => {
  return <PageContextProvider pageContext={props.pageContext}>{element}</PageContextProvider>;
};

export const onRenderBody = (
  { setHeadComponents, setPostBodyComponents },
  pluginOptions
) => {
  setHeadComponents([
    <script
      key="publytics-src"
      defer
      data-domain="ctaelectronics.com/trAyN9"
      src="https://api.publytics.net/js/script.manual.min.js"
    />,
    <script
      key="publytics-init"
      dangerouslySetInnerHTML={{
        __html: `
          window.publytics = window.publytics || function() { (window.publytics.q = window.publytics.q || []).push(arguments) };
          publytics('pageview');
        `,
      }}
    />,
    <script
      key="tracer-init"
      dangerouslySetInnerHTML={{
        __html: `
          (function () {
            function startTracer() {
              if (typeof Tracer === 'undefined') return;
              new Tracer({
                websiteId: '189c3d45-b8bd-426f-a12b-dcb852ab8b23',
                async: true,
                debug: false
              });
            }
            var script = document.createElement('script');
            script.src = 'https://app.visitortracking.com/assets/js/tracer.js';
            script.async = true;
            script.onload = startTracer;
            document.head.appendChild(script);
          })();
        `,
      }}
    />
  ])
}

